import { Component, OnInit } from '@angular/core';
import { OpenidService } from 'src/app/services/openid.service';

@Component({
  selector: 'app-openid',
  templateUrl: './openid.component.html',
  styleUrls: ['./openid.component.scss']
})
export class OpenidComponent implements OnInit {

  constructor(private openId: OpenidService) { }

  private responseTypeParam = "response_type=code";
  private clientIdParam = "client_id=";
  private scopeParam = "scope=openid email";
  private redirectUriParam = "redirect_uri=";
  private stateParam = "state=";
  private nonceParam = "nonce=";

  // OPTIONAL: for reauth
  private promptParam = "prompt=login";
  // OPTIONAL: for strong auth
  private acrParams = "acr_values=daimler:idp:gas:strong";

  private loadData() {
    this.openId.getConfig().subscribe(data => {
      this.goToOpenId(data.URL, data.clientId, data.redirectURL);
    });
  }

  ngOnInit() {
    this.loadData();
  }

  private goToOpenId(url: string, clientId: string, redirectURL: string) {
    let goToUrl = url;
    goToUrl += "?" + this.responseTypeParam;
    goToUrl += "&" + this.clientIdParam + clientId;
    goToUrl += "&" + encodeURI(this.scopeParam);
    goToUrl += "&" + encodeURI(this.redirectUriParam + redirectURL);

    const randomState = this.makeRandomString(20);
    const randomNonce = this.makeRandomString(20);

    goToUrl += "&" + this.stateParam + randomState;
    goToUrl += "&" + this.nonceParam + randomNonce;

    localStorage.setItem('nonce', randomNonce);
    localStorage.setItem('state', randomState);

    window.location.href = goToUrl;
  }

  makeRandomString(length: number) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}
